import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { InvestigationReportOut } from '@/types/alerts';

/**
 * POST /api/v1/investigate/alerts/{id}/investigate — kicks off the synchronous
 * Layer-5 LLM run. Latency is 5-20 minutes so callers should show a long
 * spinner. The router prefix is `/investigate`, then the path under it is
 * `/alerts/{id}/investigate`.
 */
export function useInvestigate(alertId: number | undefined) {
  const qc = useQueryClient();
  return useMutation<InvestigationReportOut, Error, void>({
    mutationFn: async () => {
      const resp = await api.post<InvestigationReportOut>(
        `/investigate/alerts/${alertId}/investigate`,
      );
      return resp.data;
    },
    onSuccess: (data) => {
      qc.setQueryData(['investigation', alertId], data);
    },
  });
}
